import { AfterContentChecked, AfterContentInit, AfterViewChecked, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { DataService, CustomerService, SiteTypeService, DashboardService, MapService, FireForesightService } from '../../../api/services';
import { SiteType, SiteTwin, MapLayerItem, Incident } from '../../../api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { MapComponent } from 'src/app/components/map/map.component';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { IconService } from 'src/service/icon.service';

import * as Sidebar from 'src/app/components/map/leaflet.sidebar';
import * as WindBarb from 'src/app/components/map/leaflet.windbarb';
//import * as L from 'leaflet';
import * as L from 'leaflet';
import 'leaflet-semicircle';
//import semiCircle from 'leaflet-semicircle';
import { isNumber } from 'highcharts';
import { MapLayerTableService } from 'src/service/map-layer.service';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { DashboardSelection } from 'src/app/models/dashboard';
import { FireService } from 'src/service/fire.service';

declare let L;

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.css'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class SitesComponent implements OnInit, AfterContentChecked, AfterContentInit, AfterViewChecked {
  //@ViewChild('dashboardViewer', { read: DashboardComponent, static: true }) dashboard: DashboardComponent;
  @ViewChildren(DashboardComponent) dashboards!: QueryList<DashboardComponent>;
  
  @ViewChild('streetMap', { read: MapComponent, static: true }) map: MapComponent;
  @ViewChild('sidebar') sidebarDiv: ElementRef;
  @ViewChild('sites') sitesDiv: ElementRef;
  @ViewChild('layers') layersDiv: ElementRef;
  @ViewChild('fireforesight') fireforesightDiv: ElementRef;

  
  loading: boolean = false;
  title = "app";
  fullScreen: boolean = false;
    
  public allTimeSeries: SiteTwin[];
  public results: SiteTwin[];
  //public siteType: SiteType;
  public columns: string[] = [];

  public siteTypes: SiteType[];
  
  public selectedSite: SiteTwin;
  public itemSelected: boolean = false;

  public mapLayers : MapLayerItem;
  //selectedLayers: {};

  tasAlertsSelected: boolean = false;
  tasAlerts: any;
  private init: boolean = false;

  constructor(
    private decimalPipe: DecimalPipe,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private app: ApplicationConfigService,
    private data: DataService,
    private customerService: CustomerService,
    private siteTypeService: SiteTypeService,
    public azureAuthService: AzureAuthService,
    public icons: IconService,
    public mapService: MapService,
    public fire: FireService, 
    private toasterService: ToastrService) {
      app.customerChanged$.subscribe(cid => {
        this.ngOnInit();
        this.initMap();
        this.icons.getPins(null);
      });
      this.icons.getPins(null); 
  } 

  ngAfterContentChecked(): void {
    if (!this.init){
      this.ngOnInit();
    }
  }
  
  ngAfterViewChecked(): void {
    /*console.log("After View Checked");
    if (this.init == false){
      this.ngOnInit();
    }*/
  }

  ngAfterContentInit(): void {
    /*console.log("After View Init");*/
    /*if (!this.init){
      this.initMap();
    }*/
  }
  
  ngOnInit() {
    // if (this.azureAuthService.isGlobalViewer()){
      // if (this.app.customers == null && this.azureAuthService.userProfile){
      //   this.customerService.CustomerGetAllCustomers().subscribe(c => {           
      //     this.app.customers = c;//.filter(c=>c.active);          
      //   });
      // }
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
  }

  mapReadyForInit(map){
    this.initMap();
  }

  sidebar: any;
  initMap(){
    //this.dashboard.clear();
    if (this.map && this.map.map && !this.init)
    {
      if (this.app.customer){
        this.map.map.setView([this.app.customer.centreMapLatitude, this.app.customer.centreMapLongitude],this.app.customer.zoomLevel);
      }
      
      this.init = true;
      console.log("Side Bar Init");
      this.sidebar = Sidebar.sidebar({
        autopan: false,       // whether to maintain the centered map point when opening the sidebar
        closeButton: true,    // whether t add a close button to the panes
        //container: 'sidebar', // the DOM container or #ID of a predefined sidebar container that should be used
        position: 'left',     // left or right
      }).addTo(this.map.map);

      this.siteTypeService.SiteTypeGetAll(this.app.customerId).subscribe(r => {
        this.siteTypes = r.filter(rr => rr.visible);        
      });

      if (this.app.customerId == null){
        this.app.setApplications(this.azureAuthService.userProfile);
      }


      // get the available layers
      this.mapService.MapGetMapLayerTree(this.app.customerId).subscribe(r => {
        this.mapLayers = r;
        console.log(this.mapLayers);
        
          this.sidebar.addPanel({
            id:   'side-sites',
            tab:  '<i class="bi bi-stack"></i>',
            title: 'Layers',
            pane: this.sitesDiv.nativeElement,
          });
        
        if (this.app.settings.features.indexOf('fireforesight') >= 0 || this.app.applicationAllowed("fire-foresight") ){
          console.log("Loading Fire Foresight");
          // load the latest fires and show on the map
          this.sidebar.addPanel({
            id:   'fire-foresight',
            tab:  '<i class="bi bi-fire"></i>',
            title: 'Fire Foresight',
            pane: this.fireforesightDiv.nativeElement,
          });
          this.fire.get(false);
        }
          
      });
    } /*else if (this.sidebar){
      // update the side bar
      
      if (this.app.settings.features.indexOf('fireforesight') >= 0 || this.app.applicationAllowed("fire-foresight") ){
        console.log("Loading Fire Foresight");
        // load the latest fires and show on the map
        this.sidebar.addPanel({
          id:   'fire-foresight',
          tab:  '<i class="bi bi-fire"></i>',
          title: 'Fire Foresight',
          pane: this.fireforesightDiv.nativeElement,
        });
        this.fire.get();
      }else{
      }
    }*/
    
  }


  getIcon(site: SiteTwin, pins: any[]){
    //const siteType = this.siteType;
    const siteType = this.siteTypes.find(st => st.siteTypeCode == site.siteType);

    //xsite.siteType?
    //if (site.siteType.includes("Weather Station")){
    if (siteType.displayMode == 1){
      // find the variables to populate
      //const temp = site.parameters.find(p => p.unitType == "Air Temperature")?.latestValue.value;
      const onehour = 3600000*100;
      var speed = 0;
      var direction = 0;
      var temperature = 0;
      var time = new Date(site.latestTimeStamp);
      var now = new Date();
      var age = now.getTime() - time.getTime();
      var fillColor = '#8f8f8f'
      var reqFeatures = 0;
      if (age < onehour){
        var fillColor = '#2B85C7'
        for (var key in site.parameters){
          if (site.parameters[key].unitType == "Wind Speed"){
            var s = Number((site.parameters[key].latestValue as any).value);
            if (isNumber(s)){
              speed = s;
              reqFeatures++;
            }
          }
          if (site.parameters[key].unitType == "Wind Direction"){
            var d = Number((site.parameters[key].latestValue as any).value);
            if (isNumber(d)){
              if (d >= 0 && d <= 360){
                direction = d;
                reqFeatures++;
              }
            }
          }
          if (site.parameters[key].unitType == "Air Temperature"){
            temperature = Number((site.parameters[key].latestValue as any).value);
            if (isNumber(temperature)){
              if (temperature > 30){
                fillColor = "#F00"
              } else if (temperature > 20){
                fillColor = "#ff7b00"
              } else if (temperature > 10){
                fillColor = "#e5ff00"
              } else {
                fillColor = "#0044ff"
              }
            } else {
              fillColor = "#0044dd"
            }
          }
        }
      }
      if (reqFeatures > 1){
        const icon = WindBarb.icon({lat: site.latitude, deg: direction, speed: speed, pointRadius: 6, strokeLength: 20, fillColor: fillColor});
        return {icon:icon, name: site.siteName};
      } else if (temperature) {
        const icon = WindBarb.icon({lat: site.latitude, deg: 0, speed: 0, pointRadius: 5, strokeLength: 20, fillColor: fillColor});
        return {icon:icon, name: site.siteName};
      }
      else {
        const icon = WindBarb.icon({lat: site.latitude, deg: 0, speed: 0, pointRadius: 3, strokeLength: 20, fillColor: '#0044dd'});
        return {icon:icon, name: site.siteName};
      }
    }
    
    // todo: change this to use the se
    const icon = this.icons.pinsById[siteType.mapPinId] ?? pins["blueSelected"];
    //console.log(icon);
    return  {icon:icon, name: site.siteName};
  }

  showSiteType(siteType){
    console.log(siteType);
    siteType.shown = !siteType.shown;

    if (siteType.shown){
      //todo: load sites of that site type
      if (siteType.layer){
        this.map.showLayer(siteType.layer); 
      } else {
        this.siteTypeService.SiteTypeSearch({ type:siteType.siteTypeCode, customerId: siteType.customerId, search: '', searchSize: 500, pageIndex: 0, filterOld: false})
        .subscribe(r => {
          siteType.items = r;

          siteType.layer = this.map.displaySites(siteType.items, 
            (a,b) => this.getIcon(a,b), 
            site => this.renderSiteType(site), 
            (marker,site) => this.selectSite(marker,site), false);
          //this.results.concat(r);
        });
      }
    } else if (siteType.layer) {
      this.map.removeLayer(siteType.layer);
    }
  }

  renderSiteType(site: SiteTwin){
    /*if (site.siteType == "Fire Camera"){
      var items = [];
        if (param.fires){
          for (let fire of param.fires){
            items.push(
              L.semiCircle([site.latitude, site.longitude], {
                radius: 25000 * ((90 - fire.elevation)/90),
                startAngle: fire.bearing - (fire.width/2),
                stopAngle: fire.bearing + (fire.width/2),
                lineColor: 'red'
              }));
              console.log('FIRE', site, fire);
          }
        }
      }
      return items;
    }*/
    return null;
  }

  toggle(){
    // toggle is called when you want to expand or shrink the contents for a selected site. 
    // so if you expand you might show different content to when its shrunk.
    this.fullScreen = !this.fullScreen;
    if (this.fullScreen){
      if (this.selectedSiteType && this.selectedSiteType.dashboards && this.dashboards){
        for (let dashboard of this.dashboards){
          dashboard?.reload({dashboardId:this.selectedSiteType.dashboards[0].dashboardId, siteUri:this.selectedSite.siteUri} as DashboardSelection);
        }
      }
    }else if (this.dashboards) {
      for (let dashboard of this.dashboards){
        dashboard?.clear();
      }
    }
  }

  toggleFireIncident(incident){
    incident.shown = !incident.shown;

    var fireCameras = this.siteTypes.find(s => s.siteTypeCode ==  "Fire Camera");
    if (!(fireCameras as any).shown){
      this.showSiteType(fireCameras);
    }
    if (incident.shown){      
      var siteTwin = this.fire.cameras.find(c=> c.siteUri == incident.site.siteUri);
      if (!(siteTwin as any).shown){
        (siteTwin as any).shown = !(siteTwin as any).shown;
      }
      if (incident.initialLocationLat && incident.initialLocationLon) {
        this.map.showIncidentLocation({identifier:incident.incidentId,latitude:incident.initialLocationLat, longitude:incident.initialLocationLon}, this.icons.pins['Fire Detection'], 
          () => {            
            console.log(incident);
            this.selectedSite =  { 
              siteType : "Fire Incident",
              siteName : incident.site.name + " #" + incident.incidentId,
              incident: incident
            } as any ;
            this.selectedSiteType = {
              siteTypeCode : "Fire Incident",
              displayMode : 4 
            } as any
          });
      }
      // show the detection even if there is a pin
      if (incident.bearing && incident.width) {
        this.map.displayDetection(incident.incidentId, siteTwin, incident.bearing, incident.width);      
      }
    } else{
      if (incident.initialLocationLat && incident.initialLocationLon) {
        // remove location
        this.map.removeIncidentLocation(incident.incidentId);
      }
      if (incident.bearing && incident.width) {
        this.map.hideDetection(incident.incidentId);   
      }
    }
  }

  toggleFireForesight(status){
    status.shown = !status.shown;
    for (let i of this.fire.incidents.filter(i => i.status.statusId == status.statusId)){
      if ((i as any).shown == status.shown){
        this.toggleFireIncident(i);
      }
    }
  }

  selectedSiteType: SiteType;

  selectSite(marker: L.Marker, site: SiteTwin){
    if (this.dashboards) {
      for (let dashboard of this.dashboards){
        dashboard?.clear();
      }
    }

    this.itemSelected = true;
    this.selectedSite = site;

    this.selectedSiteType = this.siteTypes.find(s => s.siteTypeCode ==  site.siteType);
    // fetch a full copy with dashboards attached
    this.siteTypeService.SiteTypeGetById({customerId: this.app.customerId, siteTypeId: this.selectedSiteType.siteTypeId}).subscribe(r => {
        this.selectedSiteType = r;        
      }, err => {
        console.log("Failed to load site type")
      });
    //console.log("selectedSiteType", this.selectedSiteType);
    
    //this.selectedDashboardId = this.siteType.dashboards[0].dashboardId;
    //this.dashboard.reload({dashboardId:this.selectedDashboardId, siteUri:this.selectedSiteUri} as DashboardSelection);
  }

  closeSite(){
    this.selectedSite = null;
    this.selectedSiteType = null;
    this.fullScreen = false;
    if (this.dashboards) {
      for (let dashboard of this.dashboards){
        dashboard?.clear();
      }
    }
  }

  public changeMap(map){
    this.map.setLayer(map);
  }

  public toggleSite(site){
    //site.shown = !site.shown;
    this.showSiteType(site);
  }

  //toggleDebounceTimeout: any;
  public toggleLayer(layer:MapLayerItem){
    if ((layer as any).layer != null){
      this.map.removeLayer((layer as any).layer);
      (layer as any).layer = null;
      (layer as any).shown = false;
    }
    else if (!(layer as any).shown){
      (layer as any).shown = true;
      console.log(layer);
      if (layer.layerTypeId == 1){
        // geojson
        this.data.DataProxy(layer.url).subscribe(resp => {
          var j = JSON.parse(resp);
          (layer as any).layer = this.map.loadLinkLayerContent('geojson', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
        });
      }
      else if (layer.layerTypeId == 2){
        // kml/kmz
        if (layer.url.slice(-3).toLowerCase() == "kmz"){
          // KMZ files need to be fetched as binary, so pass URL directly
          var l = this.map.loadLinkLayerContent('kmz', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
            console.log(feature);
            this.selectedSite = feature;
          });
          (layer as any).layer = l;
        } else {
          // KML files can be fetched as text
          this.data.DataProxy(layer.url).subscribe(resp => {
            const parser = new DOMParser();
            const kml = parser.parseFromString(resp, 'text/xml');
            // Resolve relative href URLs (icons, ground overlays) against the original KML source
            const hrefEls = kml.getElementsByTagName('href');
            for (let i = 0; i < hrefEls.length; i++) {
              const val = (hrefEls[i].textContent || '').trim();
              if (val && !val.startsWith('http') && !val.startsWith('data:') && !val.startsWith('#')) {
                try { hrefEls[i].textContent = new URL(val, layer.url).href; } catch {}
              }
            }
            var l = this.map.loadLinkLayerContent('kml', layer.mapLayerId, kml, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
              console.log(feature);
              this.selectedSite = feature;
            });
            (layer as any).layer = l;
          }, err => {
            //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
          });
        }
      }
      else if (layer.layerTypeId == 3){
        // esri
        (layer as any).layer = this.map.loadLinkLayerContent('esri', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
      }
      else if (layer.layerTypeId == 4){
        // cap
        this.data.DataProxy(layer.url).subscribe(resp => {
          var j = JSON.parse(resp);
          var l = this.map.loadLinkLayerContent('cap', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
            console.log(feature);
            this.selectedSite = feature;
          });
          (layer as any).layer = l;
        }, err => {
          //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
        });
      }
      else if (layer.layerTypeId == 5){
        // wms
        var l = this.map.loadLinkLayerContent('wms', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
          this.selectedSite = feature;
        });
        (layer as any).layer = l;
      }
      else if (layer.layerTypeId == 7){
        // tilemap
        var l = this.map.loadLinkLayerContent('tilemap', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
          this.selectedSite = feature;
        });
        (layer as any).layer = l;
      }
      else if(layer.layerTypeId == 8)
      {
        //wa emergency maps

        //this is not implemented fully yet
        //but is here for future to decode the additional data
        //that's packed in a dat file
        if (layer.url.slice(-3).toLowerCase() != "dat") {
          this.data.DataProxy(layer.url).subscribe(resp => {
            var j = JSON.parse(resp);
            (layer as any).layer = this.map.loadLinkLayerContent('waemergency', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
              //console.log(feature);
              this.selectedSite = feature;
            });
          });
        }
        else{

          //TODO: This can't be loaded through the proxy
          //but also it's just not finished but probably not needed
          (layer as any).layer = this.map.loadLinkLayerContent('waemergency-dat', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
              //console.log(feature);
              this.selectedSite = feature;
          });

        }
      }
    }
    
  }

  
  public toggleTasAlerts(){
    if (this.tasAlertsSelected == false){
      this.tasAlertsSelected = true;
      if (this.tasAlerts){
        this.map.showLayer(this.tasAlerts);
      } else {
        this.data.DataProxy("https://alert.tas.gov.au/data/data.geojson").subscribe(resp => {
          var tasAlerts = JSON.parse(resp);
          this.tasAlerts = this.map.loadLinkLayerContent('geojson', null, tasAlerts, null, null, null, false, feature => {
            console.log(feature);
            this.selectedSite = feature;
          });
        }, err => {
          //this.toasterService.("Map Layer",)
        });
      }
    } else {
      if (this.tasAlerts){
        this.map.removeLayer(this.tasAlerts);
      }
      this.tasAlertsSelected = false;
    }
  }

  getValue(item: SiteTwin, column: string){
    for (let key in item.parameters){
      var val = item.parameters[key];
      if (val.name == column){
        var latest = val.latestValue;
        return this.decimalPipe.transform((latest as any).value, '1.0-2');
      }
    }
    return "-";
  }

  getUnits(item: SiteTwin, column: string){
    for (let key in item.parameters){
      var val = item.parameters[key];
      if (val.name == column){
        return val.units;
      }
    }
    return "";
  }

  getTime(item){
    //return item.age;
    return "recent";
  }


  mapTabSelected(){
    this.map?.redraw();
  }
}
